/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RouterCreationDto } from '../../models/router-creation-dto';
import { RouterCreationResponse } from '../../models/router-creation-response';

export interface PostNewRouter$Params {
      body?: RouterCreationDto
}

export function postNewRouter(http: HttpClient, rootUrl: string, params?: PostNewRouter$Params, context?: HttpContext): Observable<StrictHttpResponse<RouterCreationResponse>> {
  const rb = new RequestBuilder(rootUrl, postNewRouter.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RouterCreationResponse>;
    })
  );
}

postNewRouter.PATH = '/routers';
